export default "__VITE_ASSET__188a6b15__"